// TypingIndicator — 3 dots pulsantes para indicar digitação
import { h } from 'preact';
import { T } from '../../styles/tokens';

export function TypingIndicator() {
  return (
    <div style={{ fontSize: 14, color: T.textMuted, display: 'flex', alignItems: 'center', gap: 4 }}>
      <span style={{ animation: 'pulse 1.2s ease-in-out infinite' }}>●</span>
      <span style={{ animation: 'pulse 1.2s ease-in-out 0.2s infinite' }}>●</span>
      <span style={{ animation: 'pulse 1.2s ease-in-out 0.4s infinite' }}>●</span>
    </div>
  );
}
